import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import WholeMilkProduct from 'models/WholeMilkProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  milkTypeOptions,
  containerSizeOptionsDefault,
  wholeContainerSizeOptions,
  lactoseContainerSizeOptions,
  evaporatedContainerSizeOptions,
  packagingInitialState,
} from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'

const WholeMilkPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  // eslint-disable-next-line no-unused-vars
  const [packaging, setPackaging] = useState(packagingInitialState)

  const [containerSizeOptions, setContainerSizeOptions] = useState(
    containerSizeOptionsDefault
  )

  const setContainerSize = () => {
    if (current.WholeMilkType === 'Whole') {
      setContainerSizeOptions(wholeContainerSizeOptions)
    } else if (current.WholeMilkType === 'Whole Lactose Free') {
      setContainerSizeOptions(lactoseContainerSizeOptions)
    } else if (current.WholeMilkType === 'Whole Evaporated') {
      setContainerSizeOptions(evaporatedContainerSizeOptions)
    }
  }

  const containerSizeReset = () => {
    methods.reset(
      { WholeMilkSize: '' },
      {
        errors: false, // errors will not be reset
        dirtyFields: false, // dirtyFields will not be reset
        dirty: false, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    )
  }

  const { setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (current?.category === packagingInitialState.category) {
      const { category, subCategory, WholeMilkType, WholeMilkSize } = current
      setPackaging({
        category,
        subCategory,
        WholeMilkType: {
          value: WholeMilkType || '',
          label: WholeMilkType.length > 0 ? WholeMilkType : 'Milk Type',
        },
        WholeMilkSize: {
          value: WholeMilkSize || '',
          label: WholeMilkSize.length > 0 ? WholeMilkSize : 'Container Size',
        },
      })
      setContainerSize()
    } else if (!updating) {
      setCurrent(WholeMilkProduct)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (current?.fkCategory === packagingInitialState.category) {
      setContainerSize()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Milk Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={milkTypeOptions}
          name="WholeMilkType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Milk Type'}
          onChange={([selected]) => {
            containerSizeReset()
            setSelect(selected, 'WholeMilkType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="WholeMilkType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>
            Size {current?.WholeMilkType !== '' ? asterisk : null}
          </strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={containerSizeOptions}
          name="WholeMilkSize"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Size'}
          onChange={([selected]) => {
            setSelect(selected, 'WholeMilkSize')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="WholeMilkSize"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
      </Col>
    </Row>
  )
}

export default WholeMilkPackage
